export type AiFeedbackVariant = 'motion' | 'human' | 'vehicle' | 'gun';

export interface AiFeedbackVariantConfig {
  readonly id: AiFeedbackVariant;
  readonly bannerBg: string;
  readonly iconSrc: string;
  readonly prompt: string;
}

export const AI_FEEDBACK_VARIANTS: Record<AiFeedbackVariant, AiFeedbackVariantConfig> = {
  motion: {
    id: 'motion',
    bannerBg: '#231600',
    iconSrc: '/assets/events/icons/ai-feedback/false-motion.svg',
    prompt: 'Tag as False Motion Detection?',
  },
  human: {
    id: 'human',
    bannerBg: '#001028',
    iconSrc: '/assets/events/icons/ai-feedback/false-human.svg',
    prompt: 'Tag as False Human Detection?',
  },
  vehicle: {
    id: 'vehicle',
    bannerBg: '#002600',
    iconSrc: '/assets/events/icons/ai-feedback/false-vehicle.svg',
    prompt: 'Tag as False Vehicle Detection',
  },
  gun: {
    id: 'gun',
    bannerBg: '#240202',
    iconSrc: '/assets/events/icons/ai-feedback/false-gun.svg',
    prompt: 'Tag as False Gun Detection',
  },
};

export interface AiFeedbackConfirm {
  readonly detectionId: string;
  readonly variant: AiFeedbackVariant;
}
